const descriptions = {
  success: 'Thank you for working with us, your vote means a lot.',
  hasFeedback: 'Thanks! Your vote & feedback has been taken into account.',
  error:
    'Something went wrong, we are working on the issue, please try again later.',
}

export { descriptions }



// WEBPACK FOOTER //
// ./src/Containers/NpsScoreVotedPage/options.js